import React, { FC, useState } from 'react';
import { quizData, Archetype } from "./ToastTypes";

import { Button } from 'components/button/Button';

import './Quiz.css';
// import { ShareSection } from './ShareQuizResult';

function useQuiz() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [answers, setAnswers] = useState<Archetype[]>([]);
  const [result, setResult] = useState<Archetype | null>(null);

  const handleAnswer = (archetype: Archetype) => {
    const updated = [...answers, archetype];
    setAnswers(updated);

    if (currentIndex + 1 >= quizData.length) {
      const finalResult = calculateResult(updated);
      setResult(finalResult);
    } else {
      setCurrentIndex(currentIndex + 1);
    }
  };

  const calculateResult = (answers: Archetype[]): Archetype => {
    const scoreMap: Record<Archetype, number> = {
      classic: 0,
      ham: 0,
      spicy: 0,
      green: 0,
      honey: 0,
      garlic: 0,
      pickle: 0,
      butter: 0,
      eggstra: 0,
    };

    answers.forEach((a) => {
      scoreMap[a]++;
    });

    // Handle tie logic
    const maxScore = Math.max(...Object.values(scoreMap));
    const topArchetypes = Object.entries(scoreMap)
      .filter(([_, score]) => score === maxScore)
      .map(([a]) => a as Archetype);

    // Return first in case of tie, or pick randomly:
    return topArchetypes[Math.floor(Math.random() * topArchetypes.length)];
  };

  return {
    question: quizData[currentIndex],
    currentIndex,
    total: quizData.length,
    handleAnswer,
    result,
    reset: () => {
      setAnswers([]);
      setResult(null);
      setCurrentIndex(0);
    },
  };
}

export const QuizFlow: FC = () => {
  const { question, handleAnswer, result, currentIndex, total, reset } = useQuiz();
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  const resultSrc = `${process.env.PUBLIC_URL}/assets/quiz/${result}.png`;

  const handleNativeShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: `I'm a ${result} toastie! 🍞🔥`,
          text: `What toastie are you? Find your flavour at toastie.au/quiz @toastiehealth`,
          url: window.location.href,
        });
      } catch (error) {
        console.error("Error sharing", error);
      }
    } else {
      alert("Sharing is not supported on your device. Try downloading the image instead.");
    }
  };



  if (result) {
    return (
      <div>
        {/* <h2>The results are in!</h2> */}
        <img
          src={resultSrc}
          alt="Toastie Result"
          className="quiz-image result"
        />
        <Button className="retake" onClick={reset} label="Retake Quiz"></Button>
        {isMobile ? (
          <a href={`/assets/quiz/${result}.png`} download="toastie-result.png">
            <Button label="Download & Share" onClick={handleNativeShare}/>
          </a>
          ) : (
            <a href={`/assets/quiz/${result}.png`} download="toastie-result.png">
              <Button label="Download & Share" onClick={() => {}}/>
            </a>
          )}
        {/* <Button label="Copy Caption" onClick={copyToClipboard} /> */}
        {/* <ShareSection 
          imageUrl={`/assets/quiz/${result}.png`}
          archetypeName="Classic Cheese"
        /> */}
      </div>
    );
  }

  return (
    <div>
      <p>Question {currentIndex + 1} / {total}</p><br/>
      <h2>
        {question.question}
      </h2><br/>
      {question.options.map((opt) => (
        <Button
          className="quiz-btn"
          label={opt.text}
          key={opt.text}
          onClick={() => handleAnswer(opt.archetype)}
        />
      ))}
    </div>
  );
};
